import { render, staticRenderFns } from "./NewOrderView.vue?vue&type=template&id=88b62a44&scoped=true&"
import script from "./NewOrderView.vue?vue&type=script&lang=js&"
export * from "./NewOrderView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=88b62a44&scoped=true&lang=css&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=88b62a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b62a44",
  null
  
)

export default component.exports